import {Component, OnInit} from '@angular/core';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Country, State} from "../../core/country-state";

declare var $: any;
declare var jQuery: any;
declare var autosize: any;
declare var swal: any;

@Component({
    selector: 'app-editprofile',
    templateUrl: './edit.page.html'
})

export class EditProfilePage implements OnInit {
    public states: any = State;
    public countries: any = Country;
    public model: any;

    constructor(private modalService: NgbModal) {
    }

    openModal(content) {
        this.modalService.open(content);
    }

    ngOnInit() {}

}

